import './OkulyonetimFooter.scss'

import { MailFilled, ShoppingCartOutlined } from '@ant-design/icons'
import { AppRoutes } from 'App'
import CenteredLayout from 'components/centered-layout/CenteredLayout'
import { Okul } from 'gql/StaticTypes'
import { Link } from 'react-router-dom'

// import useMediaQuery from '../../../hooks/useMediaQuery'
import { ReactComponent as Digital } from '../okulyonetim-tabs/tabs-icons/digital.svg'
import { ReactComponent as EnglishBook } from '../okulyonetim-tabs/tabs-icons/engbook.svg'
import { ReactComponent as ReadingBook } from '../okulyonetim-tabs/tabs-icons/readingbook.svg'
import { ReactComponent as Shop } from '../okulyonetim-tabs/tabs-icons/shop.svg'
import { ReactComponent as TurkBook } from '../okulyonetim-tabs/tabs-icons/trbook.svg'
import { OkulYonetimTabsType } from '../okulyonetim-tabs/type'
import { ReactComponent as AdminLogo } from './footer-images/admin.svg'
import { ReactComponent as CallCenter } from './footer-images/call-center.svg'
import kirtasiye from './footer-images/kirtasiye.png'
import okulLogo from './footer-images/okulogo.png'

interface OkulYonetimTabsProps {
  okul: Okul
  logo: string
  renk1: string | null | undefined
  renk2: string | null | undefined
}

const OkulyonetimFooter: React.FC<OkulYonetimTabsProps> = ({ okul, logo, renk1, renk2 }) => {
  // const isMobile = useMediaQuery(600)

  //footerda tabları göstermek için veriyi burada da çağırdık
  const Tabs: OkulYonetimTabsType[] = [
    {
      url: `${AppRoutes.okulyonetim.foreignLanguageBoooks}`,
      icon: <EnglishBook className="tab-icon" />,
      title: 'Yabancı Dil Kitapları',
      key: '1',
    },
    {
      url: `${AppRoutes.okulyonetim.turkishBoooks}`,
      icon: <TurkBook className="tab-icon" />,
      title: 'Türkçe Kitaplar',
      key: '2',
    },
    {
      url: `${AppRoutes.okulyonetim.readingBoooks}`,
      icon: <ReadingBook className="tab-icon" />,
      title: 'Okuma Kitapları',
      key: '3',
    },
    {
      url: `${AppRoutes.okulyonetim.stationary}`,
      icon: <Shop className="tab-icon" />,
      title: 'Kırtasiye',
      key: '4',
    },
    {
      url: `${AppRoutes.okulyonetim.digitalProducts}`,
      icon: <Digital className="tab-icon" />,
      title: 'Dijital Ürünler',
      key: '5',
    },
  ]
  const filteredTabs = Tabs.filter((tab) => okul.okul_kategorileri?.includes(tab.key))

  return (
    <>
      <div className="db-okulyonetim-footer">
        <div
          className="footer-bg-color-div"
          style={{
            background: `linear-gradient(
                          ${renk2 || 'rgb(199, 211, 1)'} 0%, 
                          ${renk2 || 'rgb(199, 211, 1)'} 5%, 
                          ${renk1 || 'rgb(44, 114, 34)'} 5%, 
                          ${renk1 || 'rgb(44, 114, 34)'} 100%
                        )`,
          }}
        >
          <CenteredLayout maxWidth={1250}>
            <div className="footer-top">
              <div className="footer-logo">
                <div className="up-logo">
                  <img className="okul-logo" src={logo} alt="" />
                </div>
                <img className="okul-sepeti-logo" src={okulLogo} alt="okul-sepeti" />
              </div>
              <div className="footer-tabs">
                <h3>Kategoriler</h3>
                <div className="tab-content-footer">
                  {filteredTabs.map((tab) => {
                    return (
                      <Link to={`/okulyonetim/${tab.url}`} key={tab.url}>
                        <div className="tab-content">
                          <div className="tab-logo">{tab.icon}</div>
                          <div className="tab-title">{tab.title}</div>
                        </div>
                      </Link>
                    )
                  })}
                </div>
              </div>
              <div
                style={{
                  height: 200,
                  width: 1,
                  opacity: 0.3,
                  backgroundColor: `#D9D9D9`,
                }}
                className="line-div"
              ></div>
              <div className="footer-my-profil-div">
                <h3>Profil</h3>
                <Link to={`${AppRoutes.okulyonetim.base}/${AppRoutes.okulyonetim.favoriteProducts}`}>Favoriler</Link>
              </div>
              <div
                style={{
                  height: 200,
                  width: 1,
                  opacity: 0.3,
                  backgroundColor: `#D9D9D9`,
                }}
                className="line-div"
              ></div>
              <div className="footer-content-end">
                <div className="footer-content-end-top">
                  <div className="basket-info">
                    <Link to={`${AppRoutes.okulyonetim.base}/${AppRoutes.okulyonetim.addedToClass}`}>
                      <ShoppingCartOutlined />
                      <div className="add-class-title">Sınıfa Eklenenler</div>
                    </Link>
                  </div>
                  <Link to={'https://okulsepeti.com.tr/admin4schoolsalesystem/login/?next=/admin4schoolsalesystem/'}>
                    <div className="admin-login-div">
                      <AdminLogo />
                      <span>Yönetici Girişi</span>
                    </div>
                  </Link>
                  <img className="shop-img" src={kirtasiye} alt="" />
                </div>
                <div className="call-center">
                  <CallCenter />
                  <div className="down">
                    <span>Çağrı Merkezi</span>
                    <a href="tel:0850 333 22 02">0850 333 22 02</a>
                  </div>
                </div>
                <div className="mail-div">
                  <MailFilled />
                  <a href="mailto:urundestek@okulsepeti.com.tr">urundestek@okulsepeti.com.tr</a>
                </div>
              </div>
            </div>
          </CenteredLayout>
        </div>
        <div className="footer-bottom">
          <a target="_blank" href="https://www.derinbilgi.com.tr" rel="noreferrer">
            Copyright &copy; 2025 Derin Bilgi Sistemleri
          </a>
        </div>
      </div>
    </>
  )
}

export default OkulyonetimFooter
